/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamClassStudentDropdownQueryResponse,
  GetApiV1ExamClassStudentDropdownQueryParams,
  GetApiV1ExamClassStudentDropdown400,
  GetApiV1ExamClassStudentDropdown401,
  GetApiV1ExamClassStudentDropdown500,
} from "../../types/examSharedController/GetApiV1ExamClassStudentDropdown.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamClassStudentDropdown } from "../../clients/examSharedController/getApiV1ExamClassStudentDropdown.ts";

export const getApiV1ExamClassStudentDropdownQueryKey = (
  params?: GetApiV1ExamClassStudentDropdownQueryParams,
) =>
  [
    { url: "/api/v1/exam/class-student-dropdown" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ExamClassStudentDropdownQueryKey = ReturnType<
  typeof getApiV1ExamClassStudentDropdownQueryKey
>;

export function getApiV1ExamClassStudentDropdownQueryOptions(
  params?: GetApiV1ExamClassStudentDropdownQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamClassStudentDropdownQueryKey(params);
  return queryOptions<
    GetApiV1ExamClassStudentDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamClassStudentDropdown400
      | GetApiV1ExamClassStudentDropdown401
      | GetApiV1ExamClassStudentDropdown500
    >,
    GetApiV1ExamClassStudentDropdownQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamClassStudentDropdown(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a lista de turmas ativas para uso em componentes de seleção. Quando courseId é informado, filtra pelo curso. Quando companyId é informado, filtra pela empresa; caso contrário, se mainOnly for verdadeiro, retorna apenas turmas sem empresa associada. Quando monographOnly é verdadeiro, retorna apenas turmas de cursos com monografia. **(Requer Authorization para autenticação)**
 * @summary Lista de turmas para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/class-student-dropdown}
 */
export function useGetApiV1ExamClassStudentDropdown<
  TData = GetApiV1ExamClassStudentDropdownQueryResponse,
  TQueryData = GetApiV1ExamClassStudentDropdownQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamClassStudentDropdownQueryKey,
>(
  params?: GetApiV1ExamClassStudentDropdownQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamClassStudentDropdownQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamClassStudentDropdown400
          | GetApiV1ExamClassStudentDropdown401
          | GetApiV1ExamClassStudentDropdown500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamClassStudentDropdownQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ExamClassStudentDropdownQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamClassStudentDropdown400
      | GetApiV1ExamClassStudentDropdown401
      | GetApiV1ExamClassStudentDropdown500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
